import { ReviewOfSystemsData } from '../types/reviewOfSystems'

export interface ROSCategory {
  key: keyof ReviewOfSystemsData
  name: string
  items: string[]
}

export const rosCategories: ROSCategory[] = [
  {
    key: 'constitutional',
    name: 'Constitutional',
    items: ['fever', 'chills', 'fatigue', 'weightLoss', 'weightGain'],
  },
  {
    key: 'psychiatric',
    name: 'Psychiatric',
    items: [
      'depression',
      'moodSwings',
      'anxiety',
      'suicidality',
      'homicidalIdeation',
      'eatingDisorder',
    ],
  },
  {
    key: 'neurological',
    name: 'Neurological',
    items: ['seizures', 'neuromuscular', 'headaches'],
  },
  {
    key: 'eyes',
    name: 'Eyes',
    items: ['visionChange', 'doubleVision', 'wearsGlasses', 'wearsContactLenses'],
  },
  {
    key: 'earNoseThroatMouth',
    name: 'Ear, Nose, Throat & Mouth',
    items: ['earAches', 'ringing', 'sinusPain', 'soreThroat', 'mouthSores', 'dryMouth'],
  },
  {
    key: 'cardiovascular',
    name: 'Cardiovascular',
    items: [
      'chestPain',
      'swellingLeg',
      'palpitations',
      'heartMurmurs',
      'highBloodPressure',
      'heartDisease',
      'hemorrhoids',
      'varicoseVeins',
      'breathingDifficulty',
      'bloodClots',
    ],
  },
  {
    key: 'surgeries',
    name: 'Surgeries',
    items: ['cesareanSection', 'breastSurgery', 'abdominalSurgery', 'uterineSurgery'],
  },
  {
    key: 'respiratory',
    name: 'Respiratory',
    items: [
      'wheezing',
      'bloodSputum',
      'shortnessOfBreath',
      'cough',
      'asthma',
      'lung',
      'tuberculosis',
    ],
  },
  {
    key: 'skinBreast',
    name: 'Skin & Breast',
    items: [
      'breastPain',
      'nippleDischarge',
      'breastLumps',
      'rash',
      'ulcers',
      'psoriasis',
      'changingMoles',
    ],
  },
  {
    key: 'musculoskeletal',
    name: 'Musculoskeletal',
    items: [
      'weakness',
      'jointStiffness',
      'jointPain',
      'jointSwelling',
      'arthritis',
      'fractures',
      'osteoporosis',
      'osteopenia',
    ],
  },
  {
    key: 'endocrine',
    name: 'Endocrine',
    items: [
      'abnormalThirst',
      'hotFlashes',
      'tremors',
      'coldHeatIntolerance',
      'diabetes',
      'hyperthyroidism',
      'hypothyroidism',
      'thyroidDisease',
    ],
  },
  {
    key: 'hematological',
    name: 'Hematological',
    items: [
      'frequentBruising',
      'cutsBleedLong',
      'enlargedLymphNodes',
      'clottingDisorder',
      'factorV',
      'anemia',
    ],
  },
  {
    key: 'gastrointestinal',
    name: 'Gastrointestinal',
    items: [
      'diarrhea',
      'constipation',
      'nausea',
      'gastricUlcers',
      'bloodyStool',
      'abdominalPain',
      'indigestion',
      'bloating',
      'liverProblems',
      'giDisease',
    ],
  },
  {
    key: 'diseases',
    name: 'Diseases',
    items: [
      'hepatitisB',
      'hepatitisC',
      'hepOther',
      'rubella',
      'lymeDisease',
      'lupus',
      'breastCancer',
      'ovarianCancer',
      'uterineCancer',
      'colonCancer',
      'otherCancer',
      'chickenpox',
      'genitalHerpes',
      'oralHerpes',
    ],
  },
  {
    key: 'gyn',
    name: 'GYN',
    items: [
      'yeast',
      'bacterialVaginosis',
      'urinaryTractInfection',
      'kidneyInfection',
      'kidneyStones',
      'bloodUrine',
      'painUrine',
      'urgency',
      'severeMenstrualCramps',
      'urinaryFrequency',
      'urinaryIncontinence',
      'abnormalBleeding',
      'vaginalDischarge',
      'vaginalItching',
      'pelvicPain',
      'menstrualCramps',
      'painfulIntercourse',
      'genitalLumps',
      'fibroid',
      'endometriosis',
      'fertilityIssues',
      'menopausalConcerns',
      'abnormalPapSmear',
      'hpv',
      'syphilis',
      'chlamydia',
      'herpes',
      'gonorrhea',
      'trichomoniasis',
    ],
  },
]
